import { render, staticRenderFns } from "./PortfolioComponent.vue?vue&type=template&id=61d27aa8&scoped=true&"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioComponent.vue?vue&type=style&index=0&id=61d27aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d27aa8",
  null
  
)

export default component.exports